module.exports = __webpack_public_path__ + "static/media/watermelon.9bdc29da.webp";